module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img22.149ca4e0.jpg";